module.exports = __webpack_public_path__ + "e4e140269ec8df3763a4156a278197db.svg";